﻿import { InjectionToken } from '@angular/core';
import { IAppConfig } from './app.config.shared';

export let APP_CONFIG = new InjectionToken('app.config');



export const AppConfig: IAppConfig = {
  //apiEndpoint: 'http://envision-test:8883/api/',
  // apiEndpoint: 'https://wap-test.issportals.com/Envision_DEV/RestAPI/api/',
  googleMapApiKey: 'AIzaSyBGywnflFlulKvYLlSWAgUu35Jg4j31kpc',
  snapEngageKey: '9b379456-16de-4138-8fbd-0cace0da1c2f',
  parentMyAccountThirdPartyUrl: 'https://integrationserver-test.issportals.com/webapi/api/account/GetAccountStatus?AccountID=',
  parentPaymentDataThirdPartyUrl: 'https://integrationserver-test.issportals.com/webapi/api/account/Payments?AccountID=',
  // apiEndpoint: 'http://envision-test:9993/api/'
  // apiEndpoint: 'http://envision-uat:9993/api/'
  // apiEndpoint: 'http://envision-Production:9993/api/'
};

declare function require(moduleName: string): any;

export const {version : AppVersion} = require('./../../package.json');
